import React from 'react';
import SurveyGroupRow from './SurveyGroupRow/index';

const SurveyGroupList = ({ data, addFavouriteSurveyGroup, onSurveyGroupSelect, onSaveSurveyGroup, onDeleteSurveyGroup, showSurveyGroupLoader, onSurveyGroupQuestions }) => {
    return (
        <div className="app-main-content">
            {data.map((data, index) =>
                <SurveyGroupRow key={index} surveyGroup={data} onDeleteSurveyGroup={onDeleteSurveyGroup}
                    onSaveSurveyGroup={onSaveSurveyGroup} showSurveyGroupLoader={showSurveyGroupLoader}
                    addFavouriteSurveyGroup={addFavouriteSurveyGroup} onSurveyGroupSelect={onSurveyGroupSelect}
                    onSurveyGroupQuestions={onSurveyGroupQuestions}
                />
            )}

        </div>
    )
};

export default SurveyGroupList;


// WEBPACK FOOTER //
// ./components/Agile/SurveyGroup/SurveyGroupList/index.js